"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../../sections/machine-detail/types");
const updatePriceOrProduct_1 = require("../../modules/machine/app/updatePriceOrProduct");
const updateMachineCapacity_1 = require("../../modules/machine/app/updateMachineCapacity");
const updateStock_1 = require("../../modules/machine/app/updateStock");
const react_i18next_1 = require("react-i18next");
const getApiErrorMessage_1 = require("../../common/api/utils/getApiErrorMessage");
const useHandleEdit = ({ repo, id, updateAisleValues, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const handleEdit = async (micronAisleId, microProductId, aisleCode, field, values, showSuccess, showError, type) => {
        let hasErrors = false;
        try {
            if (field === types_1.EditableField.All && values && updateAisleValues) {
                updateAisleValues(micronAisleId, values);
            }
            switch (type) {
                case types_1.EditableField.Price:
                    try {
                        await (0, updatePriceOrProduct_1.updatePriceOrProduct)(repo, id ?? '', aisleCode, microProductId, values?.price || 0);
                    }
                    catch (error) {
                        console.error('Error al actualizar el precio o producto: ', error);
                        hasErrors = true;
                        if (showError)
                            showError((0, getApiErrorMessage_1.getApiErrorMessage)(t, error, 'updatePriceOrProductError'));
                    }
                    break;
                case types_1.EditableField.MaxStock:
                    try {
                        await (0, updateMachineCapacity_1.updateMachineCapacity)(repo, id ?? '', micronAisleId, aisleCode, values?.maxStock || 0);
                    }
                    catch (error) {
                        console.error('Error al actualizar la capacidad de la máquina: ', error);
                        hasErrors = true;
                        if (showError)
                            showError((0, getApiErrorMessage_1.getApiErrorMessage)(t, error, 'updateCapacityError'));
                    }
                    break;
                case types_1.EditableField.CurrStock:
                    try {
                        await (0, updateStock_1.updateStock)(repo, id ?? '', micronAisleId, aisleCode, values?.currStock || 0);
                    }
                    catch (error) {
                        console.error('Error al actualizar el stock: ', error);
                        hasErrors = true;
                        if (showError)
                            showError((0, getApiErrorMessage_1.getApiErrorMessage)(t, error, 'updateStockError'));
                    }
                    break;
                default:
                    break;
            }
            if (!hasErrors && showSuccess) {
                showSuccess(`${t('aisleUpdateSuccess')}. ${t('rememberRestartMachine')}`);
            }
        }
        catch (error) {
            console.error('Error general al actualizar los valores: ', error);
            if (showError)
                showError((0, getApiErrorMessage_1.getApiErrorMessage)(t, error, 'aisleUpdateError'));
        }
    };
    return { handleEdit };
};
exports.default = useHandleEdit;
